import { Button, Dialog } from 'components/Elements';
import { getToken, messaging } from 'lib/firebase';
import { useState, useEffect } from 'react';

export const NotificationsConsent = ({ onTokenReceived }) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (Notification.permission === 'default') {
      setShowPrompt(true);
    } else {
      console.log('Notification permission already granted or denied');
    }
  }, []);

  const handleAllow = async () => {
    try {
      setIsLoading(true);
      const token = await getToken(messaging, {
        vapidKey:
          'BHg8G7gzUpRJzqkKngahHybH3OdUQmOlxYA3q2DytjrLyFyzAh_WUG1Y38rbRyPR5frUCeaK0vnqsoSH2rNc9y8',
      });
      console.log(token);
      if (token) {
        setIsLoading(false);
        onTokenReceived?.(token);
        setShowPrompt(false);
      }
    } catch (err) {
      setIsLoading(false);
      console.error('Failed to get FCM token:', err);
    }
  };

  const handleDeny = () => {
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <Dialog isOpen={showPrompt} onClose={handleDeny} initialFocus={null}>
      <div className="inline-block align-bottom rounded-2xl px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform text-white transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 bg-[linear-gradient(to_bottom,_#2F6ACB,_#4455D0,_#4B3CBF)] dark:bg-[linear-gradient(to_bottom,_#0F2027,_#203A43,_#2C5364)]">
        <div className="">
          <h3 className="text-lg font-semibold mb-2">
            Enable Secure Session Notifications
          </h3>
          <p className="text-sm mb-4">
            To securely verify your session and provide real-time updates, Wire24 requires permission to generate a secure device token.
            This token is used during login and while refreshing your session to
            ensure reliable access and notification delivery.
          </p>
          <p className="text-sm mb-4">
            You may disable notifications later in your browser settings.
            However, granting permission is recommended for optimal
            functionality.
          </p>
          <div className="flex justify-end gap-3">
            <Button variant="darkGlass" onClick={handleDeny}>
              Not Now
            </Button>
            <Button isLoading={isLoading} variant="glass" onClick={handleAllow}>
              Allow & Continue
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
